module.exports = __webpack_public_path__ + "img/mood_tracker.00a31d28.svg";